import { useTranslation } from "react-i18next";

interface NoDataProps {
  message?: string;
  className?: string;
}

export default function NoData({
  message,
  className = "p-4 text-center text-gray-600",
}: NoDataProps) {
  const { t } = useTranslation();
  const displayMessage = message || t("common.noData");

  return <div className={className}>{displayMessage}</div>;
}
